<template>
  <div>
    <div class="sinage-wrapper">
      <div>
        <div class="row border-bottom border-dark mb-4">
          <div class="col-4 align-self-center">
            <img
              src="@/assets/img/logos/logo-white.png"
              height="auto"
              width="100"
              class="img-fluid"
              alt
            />
          </div>
          <div class="col-4">
            <div class="sinage-title">PLAYING TODAY</div>
          </div>
          <div class="col-4 justify-content-end d-flex align-items-center">
            <h5 class="mb-0">{{currentTime}}</h5>
            <h5 class="mb-0 ml-4">{{currentDate}}</h5>
          </div>
        </div>

        <slick ref="slick1" :options="silderOne">
          <div v-for="(show,showKey) in finalMovies" :key="showKey">
            <div class="single-movie">
              <img
                v-if=" show.md_thumbnail_url && show.md_thumbnail_url.length == 0"
                :src="'/static/placeholder-image.png'"
                class="rounded img-fluid d-block mx-auto"
              />
              <img
                v-else
                :src="_GetImagePath(show.md_thumbnail_url)"
                class="rounded img-fluid d-block mx-auto"
              />
              <h5>{{ show.movie_title }}</h5>

              <ul class="sinage-info">
                <li>
                  <div class="sinage-format">{{show.mf_name}}</div>
                </li>
                <li>
                  <div class="sinage-lang">{{show.lang_name}}</div>
                </li>
                <li>
                  <div>({{show.rating}})</div>
                </li>
              </ul>

              <h6></h6>

              <ul class="sinage-timing-list mb-0">
                <li
                  v-for="(showTime,ShowTimeKey) in show.showTimes"
                  :key="ShowTimeKey"
                >{{ showTime }}</li>
                <!-- <li>4:30 PM</li>
                <li>6:30 PM</li>
                <li>7:00 PM</li>-->
              </ul>
            </div>
          </div>
        </slick>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript" src= 
        "https://cdnjs.cloudflare.com/ajax/libs/underscore.js/1.9.1/underscore.js">
</script>

<script>
import signageServices from "@/services/signageService";
import Slick from "vue-slick";

export default {
  components: {
    Slick
  },
  data() {
    return {
      silderOne: {
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 40000,
        slidesToScroll: 1,
        slidesToShow: 4
      },
      finalMovies: []
    };
  },
  beforeMount() {
    this.getMovies(this.$route.params.id);
  },
  computed: {
    currentTime() {
      return this.$store.getters.CURRENT_TIME;
    },
    currentDate() {
      return this.$store.getters.CURRENT_DATE;
    }
  },
  methods: {
    getMovies: function(cinema_id) {
      signageServices
        .getSignageServices(cinema_id)
        .then(response => {
          const { data } = response;
          console.log("response :", response);
          // let uniqueArray =

          // let array = data.Records.reduce(function(acc, obj) {
          //   let key = `${String(obj["movie_details_id"])}_${String(
          //     obj["ss_start_show_time"]
          //   )}`;
          //   if (!acc[key]) {
          //     acc[key] = [];
          //   }
          //   acc[key].push(obj);
          //   return acc;
          // }, {});
          // console.log("array :", array);

          let movies = data.Records;
          movies.map(x => {
            x["showTimes"] = [];
          });
          data.Records.map(x => {
            movies.map(y => {
              if (
                x.movie_id == y.movie_id &&
                x.movie_details_id == y.movie_details_id
                // x.movie_language_id == y.movie_language_id &&
                // x.movie_format_id == y.movie_format_id
              ) {
                y.showTimes.push(x.ss_start_show_time);
              }
            });
          });

          function removeDuplicates(originalArray, prop) {
            var newArray = [];
            var lookupObject = {};

            for (var i in originalArray) {
              lookupObject[originalArray[i][prop]] = originalArray[i];
            }

            for (i in lookupObject) {
              newArray.push(lookupObject[i]);
            }
            return newArray;
          }
          this.finalMovies = removeDuplicates(movies, "movie_details_id");
          console.log("finalMovies :", this.finalMovies);
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(0, true);
          });
          // self.show_details=data.Records;
          //  console.log("Acutall",self.show_details[0].ss_id);

          //   console.log("Actual data", self.show_details);

          //  var a;
          //  for (i in self.show_details.movie_title) {
          //    a=  self.show_details.movie_title[i];
          //  }

          //     var g = _groupBy(a,function(value){
          //       return value.movie_title;
          //     });
          //      self2.singleMovie=g;

          //   var cars={[
          //     {"name":"ABCD","year":"2010"},
          //     {"name":"ABCD","year":"2010"},
          //     {"name":"Kabir","year":"2005"}
          // ]};
          // var g = _groupBy(cars, function(value){
          //    return car.name;
          // });
          // document.write(g);
        })
        .catch(error => {
          console.log("error :", error);
        });
    }
  }
};
</script>

<style>
.sinage-wrapper {
  width: 100%;
  padding: 20px;
  color: #fff;
  height: 100vh;

  overflow: hidden;
  background: #000000;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to top, #434343, #000000, #000000);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to top, #434343, #000000, #000000);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.sinage-title {
  height: 65px;
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}

.sinage-wrapper .single-movie {
  width: 90%;
  padding: 15px 20px;
  margin: 0 auto;
  text-align: left;
  border-radius: 5px;
  background: #222222;
  /* border: 1px solid grey; */
  margin-top: 10px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 10px 3px #8080807a;
}

.single-movie h5 {
  line-height: 1;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 20px;
  padding: 18px 0 15px 0;
  text-transform: uppercase;
  border-bottom: 1px solid GREY;
}

.single-movie img {
  width: 100%;
}

.sinage-info,
.sinage-timing-list {
  padding-left: 0;
  list-style: none;
  margin-bottom: 25px;
  display: inline-flex;
  flex-wrap: wrap;
}

.sinage-info li,
.sinage-timing-list li {
  border-radius: 5px;
  flex-wrap: wrap;
  display: flex;
}

.sinage-timing-list li {
  padding: 5px 15px;
  margin-bottom: 10px;
  border: 1px solid grey;
}

.sinage-timing-list li:not(:last-child) {
  margin-right: 10px;
}

.sinage-info li:not(:last-child):after {
  width: 1px;
  content: "";
  height: 20px;
  display: block;
  margin: 0 10px;
  background-color: #d3d3d3;
}

.sinage-format {
  padding: 4px 8px 3px 8px;
  display: table;
  line-height: 1;
  border-radius: 3px;
  border: 1px solid grey;
  background-color: #000000;
}

.single-movie h6 {
  font-size: 16px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Signage/signage.vue